export const css = {
    root: '_1jTIeSpU',
    videoInstructions: '_2bXRJ93W',
    videoWrapper: 'sRINY8gh',
    videoTranscript: '_3YUxNr3j',
    ' _key': 'apic-theme/apic/video/video'
};
export default css;
